<template>
    <div>
        <div class="about_us_bg contractIdenResult_bg" id="app" v-cloak>
            <div class="w_1200">
                <div class="contract_box">
                    <h3 class="title">合同鉴真</h3>
                    <div class="doctype_result clearfix">
                        <h3 class="title">{{ alldata_1.sysError}}</h3>
                        <p class="intro"><span>{{ alldata.msg }}</span>
                            最后签署时间：<span>{{ curdata.signtime || '签署无效' }}</span>
                            该PDF文件包含<span>{{ tdata || 0}}</span>个电子签名，详情如下：</p>
                        <table>
                            <colgroup>
                                <col width="20%">
                                <col width="60%">
                                <col width="20%">
                            </colgroup>
                            <tbody v-cloak>
                            <tr>
                                <td>签约人</td>
                                <td>{{ curdata.signer || '无签名'}}</td>
                            </tr>
                            <tr>
                                <td>签约时间</td>
                                <td>{{ curdata.signtime || '无信息'}}</td>
                            </tr>
                            <tr>
                                <td>证书序列号</td>
                                <td>{{ curdata.certsn || '无序列号'}}</td>
                            </tr>
                            <tr>
                                <td>颁发机构</td>
                                <td>{{ curdata.issuser || '无颁发机构'}}</td>
                            </tr>
                            <tr>
                                <td>时间戳</td>
                                <td>{{ curdata.tsatime || '无信息' }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                layout="prev, pager, next"
                                :total="tdata*10">
                        </el-pagination>

                    </div>
                </div>
                <a class="doctype_get_back" @click="fun()">
                    返回
                </a>
                <div id="sys-loading" class="">
                    <div class="spinner" id="spinner">
                        <div class="loader-inner line-scale-pulse-out-rapid">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "contractIdenResult",
        data() {
            return {
                contracturi: this.$route.params.contracturi,
                alldata: {},
                alldata_1: {},
                tdata: 0,
                curdata: {},
            }
        },
        mounted() {
            this.get_data()
        },
        methods: {
            get_data() {
                this.$SIF.httpPost({
                    url: this.$SIF._serve.manage + "/function/verify/contract",
                    data: {
                        contracturi: this.contracturi
                    },
                    succFun: res => {
                        this.subSomething()
                        if (res.data.code === 10000 || res.data.code === 0) {
                            this.alldata_1 = res
                            this.alldata = res.data
                            this.tdata = res.data.results.length
                            this.curdata = res.data.results[0].result
                        }

                    },
                    failFun: res => {
                        this.subSomething()
                        this.alldata_1 = res
                        this.alldata = res.data
                        this.tdata = res.data.results.length
                        this.curdata = res.data.results[0].result



                    }
                });
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.curdata = this.alldata.results[val - 1].result
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            subSomething() {
                setTimeout(() => {
                    var add_input = document.getElementById("sys-loading")
                    add_input.style.display = 'none'
                }, 1000);
            },
            fun() {
                this.$router.go(-1); //返回上一层
            }
        }
    }
</script>

<style scoped>
    .about_us_bg {
        background: url(~@/assets/img/banner/iden_bg.png);
    }
    @media screen and (max-width:1024px) and (min-width:320px){
        .w_1200{
            padding: 2rem 0.5rem 0 0.5rem !important;
        }
    }
</style>